import { generatePalette } from '../utils/colorUtils';
export default {
  COMMON: {
    stroke: {
      width: 1
    },
    text: {
      font: '14px sans-serif',
      fill: {
        color: 'rgb(255,255,255)'
      },
      stroke: {
        color: 'rgb(0,0,0)',
        width: 2
      }
    }
  },
  border: {
    color: 'rgb(0,0,0)',
    width: 1
  },
  AirTemperature: {
    min: -10,
    max: 30,
    color: ['rgb(128,166,128)', 'rgb(159,207,159)', 'rgb(175,223,175)', 'rgb(191,239,191)', 'rgb(207,255,207)', 'rgb(255,255,200)', 'rgb(255,255,128)', 'rgb(255,255,0)', 'rgb(255,221,17)', 'rgb(238,188,17)', 'rgb(226,120,17)', 'rgb(226,53,29)', 'rgb(239,36,80)', 'rgb(239,20,132)', 'rgb(200,12,148)', 'rgb(165,4,165)', 'rgb(255,0,255)', 'rgb(255,16,255)']
  },
  Currents: {
    min: 0,
    max: 1.5,
    color: 'rgb(128,64,64)'
  },
  CurrentsKts: {
    min: 0,
    max: 3,
    color: 'rgb(128,64,64)'
  },
  DewPoint: {
    min: -10,
    max: 25,
    color: [...generatePalette('rgb(255,255,255)', 'rgb(0,0,32)', 10), ...generatePalette('rgb(0,0,32)', 'rgb(0,0,128)', 10), ...generatePalette('rgb(0,0,128)', 'rgb(0,0,255)', 10), ...generatePalette('rgb(0,0,255)', 'rgb(0,128,128)', 10), ...generatePalette('rgb(0,128,128)', 'rgb(255,255,0)', 15), ...generatePalette('rgb(255,255,0)', 'rgb(255,0,0)', 15), ...generatePalette('rgb(255,0,0)', 'rgb(0,0,0)', 15)]
  },
  FreezingLevel: {
    min: 0,
    max: 1650,
    color: {
      from: 'rgb(0,0,0)',
      to: 'rgb(0,0,128)'
    }
  },
  HighLowPressureSymbols: {
    color: {
      high: 'rgb(128, 0, 0)',
      low: 'rgb(0, 0, 128)'
    }
  },
  HPa500: {
    min: 4800,
    max: 6000,
    color: [...generatePalette('rgb(255,255,255)', 'rgb(0,0,64)', 3), ...generatePalette('rgb(0,0,64)', 'rgb(0,0,128)', 3), ...generatePalette('rgb(0,0,128)', 'rgb(0,0,255)', 3), ...generatePalette('rgb(0,0,255)', 'rgb(0,128,128)', 3), ...generatePalette('rgb(0,128,128)', 'rgb(0,128,0)', 3), ...generatePalette('rgb(0,128,0)', 'rgb(255,255,0)', 3), ...generatePalette('rgb(255,255,0)', 'rgb(255,0,0)', 3), ...generatePalette('rgb(255,0,0)', 'rgb(128,0,0)', 3), ...generatePalette('rgb(128,0,0)', 'rgb(64,0,0)', 3), ...generatePalette('rgb(64,0,0)', 'rgb(0,0,0)', 3)]
  },
  Hurricanes: {
    color: {
      barbs: 'rgb(255,0,0)',
      past: 'rgb(0,128,0)',
      future: 'rgb(0,0,255)'
    }
  },
  IceBergPosition: {
    color: 'rgb(0,0,255)'
  },
  IceConcentration: {
    waterColor: 'rgb(216,244,225)',
    min: 0,
    max: 101,
    color: [...generatePalette('rgb(0,198,0)', 'rgb(122,255,14)', 10), ...generatePalette('rgb(122,255,14)', 'rgb(255,255,1)', 10), ...generatePalette('rgb(255,255,1)', 'rgb(199,181,0)', 10), ...generatePalette('rgb(199,181,0)', 'rgb(208,124,8)', 10), ...generatePalette('rgb(208,124,8)', 'rgb(197,53,1)', 10), ...generatePalette('rgb(197,53,1)', 'rgb(248,2,5)', 10), ...generatePalette('rgb(248,2,5)', 'rgb(246,7,134)', 10), ...generatePalette('rgb(246,7,134)', 'rgb(255,30,255)', 10), ...generatePalette('rgb(255,30,255)', 'rgb(134,37,255)', 10), ...generatePalette('rgb(134,37,255)', 'rgb(79,0,174)', 10)]
  },
  Icing: {
    min: 0,
    max: 4,
    color: 'rgb(0,0,255)'
  },
  Precipitation: {
    min: 10,
    max: 90,
    color: ['rgb(251,251,214)', 'rgb(255,255,00)', 'rgb(238,188,17)', 'rgb(226,53,29)', 'rgb(239,20,132)', 'rgb(165,4,165)', 'rgb(140,186,216)', 'rgb(66,138,181)', 'rgb(24,69,156)' // 'rgb(1,1,1)',
    ]
  },
  Pressure: {
    min: 900,
    max: 1100,
    color: {
      default: {
        lowStart: 'rgb(0,0,0)',
        low: 'rgb(0,0,128)',
        lowEnd: 'rgb(255,255,255)',
        highStart: 'rgb(255,255,255)',
        high: 'rgb(128,0,0)',
        highEnd: 'rgb(0,0,0)'
      },
      area: {
        lowStart: 'rgb(0,0,0)',
        low: 'rgb(0,0,255)',
        lowEnd: 'rgb(255,255,255)',
        highStart: 'rgb(255,255,255)',
        high: 'rgb(255,0,0)',
        highEnd: 'rgb(0,0,0)'
      }
    }
  },
  RelativeHumidity: {
    min: 20,
    max: 100,
    color: 'rgb(0,0,255)'
  },
  RiskWaveHeight: {
    min: 0.5,
    max: 9,
    color: 'rgb(34,139,34)'
  },
  RiskWindSpeed: {
    min: 5,
    max: 25,
    color: 'rgb(255,160,122)'
  },
  RiskWindSpeedKts: {
    min: 10,
    max: 50,
    color: 'rgb(255,160,122)'
  },
  SeaWaterDensity: {
    min: 1010,
    max: 1030,
    color: 'rgb(51, 51, 153)'
  },
  SeaWaterSalinity: {
    min: 14.5,
    max: 37.5,
    color: 'rgb(46,139,87)'
  },
  SeaWaterTemperature: {
    min: -2,
    max: 30,
    color: ['rgb(128,166,128)', 'rgb(159,207,159)', 'rgb(175,223,175)', 'rgb(191,239,191)', 'rgb(207,255,207)', 'rgb(255,255,250)', 'rgb(255,255,200)', 'rgb(255,255,128)', 'rgb(255,255,00)', 'rgb(255,221,17)', 'rgb(238,188,17)', 'rgb(226,120,17)', 'rgb(226,53,29)', 'rgb(239,36,80)', 'rgb(239,20,132)', 'rgb(200,12,148)', 'rgb(165,4,165)' // 'rgb(255,0,255)',
    ]
  },
  SwellPeriod: {
    min: 6,
    max: 15,
    color: 'rgb(64,0,64)'
  },
  Swell: {
    min: 0.5,
    max: 9,
    color: 'rgb(64, 128, 128)'
  },
  Visibility: {
    min: 0,
    max: 4,
    color: 'rgb(128,128,128)'
  },
  WavePeriod: {
    min: 3,
    max: 10,
    color: 'rgb(255,128,0)'
  },
  Wave: {
    min: 0.5,
    max: 9,
    color: 'rgb(0, 128, 0)'
  },
  Wind10M: {
    min: 5,
    max: 25,
    color: 'rgb(255,0,0)'
  },
  Wind10MKts: {
    min: 10,
    max: 50,
    color: 'rgb(255,0,0)'
  },
  Wind30M: {
    min: 5,
    max: 25,
    color: 'rgb(255,85,0)'
  },
  Wind30MKts: {
    min: 10,
    max: 50,
    color: 'rgb(255,85,0)'
  },
  Wind50M: {
    min: 5,
    max: 25,
    color: 'rgb(255,165,0)'
  },
  Wind50MKts: {
    min: 10,
    max: 50,
    color: 'rgb(255,165,0)'
  },
  WeatherFrontData: {
    color: {
      cold: 'rgb(0,0,255)',
      warm: 'rgb(255,0,0)',
      occluded: 'rgb(128,0,128)'
    }
  },
  WindGusts10M: {
    min: 7,
    max: 35,
    color: 'rgb(220,20,60)'
  },
  WindGusts50M: {
    min: 7,
    max: 35,
    color: 'rgb(178,34,34)'
  },
  WindGusts10MKts: {
    min: 14,
    max: 70,
    color: 'rgb(220,20,60)'
  },
  WindGusts50MKts: {
    min: 14,
    max: 70,
    color: 'rgb(178,34,34)'
  },
  WeatherCode: {
    color: 'rgb(0,0,255)'
  },
  MaxIceConcentration: {
    color: 'rgb(0,0,0)',
    width: 3
  },
  PortsPilots: {
    Port: {
      iconSrc: 'data:image/png;base64,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',
      pinCorner: [0, 153],
      iconScale: 0.2
    },
    Pilot: {
      iconSrc: 'data:image/png;base64,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',
      pinCorner: [0, 153],
      iconScale: 0.2
    },
    Clustered: {
      iconSrc: 'data:image/png;base64,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',
      pinCorner: [0, 153],
      iconScale: 0.2
    }
  },
  LegsViapoints: {
    viapoint: {
      openSrc: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAMFBMVEX///8UiSwUiSwUiSwUiSwUiSwUiSz///8UiSwAAAAAAAAAAAAAAAAAAAAAAAAAAABqDDgJAAAAB3RSTlMAEWaqu8zuQLwGJgAAAB10RVh0amlyYS1zeXN0ZW0taW1hZ2UtdHlwZQBhdmF0YXLkAhphAAAAfUlEQVR42mNmYFAud3n3nIGZQTSHgUGb9wYTYzADEJgKMLMGgRiMLEzKDAz/PzAwGDEpMIABE5MDhMHCxMDw/sP/90AhBihgYWAQ/P9RgIGBmQWo+icHwx+mBxCZf0x3gaYBZc4x/QEL/TvA9H8tiHH6AzPDt/vGDKv2MwAA3+ceFnSoTq0AAAAASUVORK5CYII=',
      closeSrc: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABuSURBVDhPYzxsoytoe+TyewYkcMHF/D+UiQIM9pxkhDLBAKQXRQCXRnSAbBCcQaxmGIAZAiZI1QwDIEOYoGyyASO5tsMA9V2gv/sElIUdXHS1gLIgYDiEAYgY2HQApSlLyjBArCEomYmy7KwrCABQhjRu7CtnTgAAAABJRU5ErkJggg=='
    },
    legs: {
      color: 'blue',
      width: 1
    }
  },
  SeaWaterDynamicViscosity: {
    min: 0.8,
    max: 2.1,
    color: 'rgb(0, 106, 78)'
  }
};